<!-- 吨位日志 -->
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/weier/mould/tonnage/change/log/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mujumingcheng')">
            <el-input v-model="yt.conditions.mouldName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianma')">
            <el-input v-model="yt.conditions.mouldCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('caozuoshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"> </yi_time_input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button
              @click="
                yt.clear(
                  (conditions = {
                    pageSize: 10,
                    orderBy: 'createTime desc',
                  })
                )
              "
              >{{ $t("chongzhi") }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="yt.exportLoading" @click="exportExcel()"></el-button>
      </template>
      <template #xiugaiqian="scope">
        {{ scope.row.tonnageMinBefore != null && scope.row.tonnageMaxBefore != null ? scope.row.tonnageMinBefore + "-" + scope.row.tonnageMaxBefore : "" }}
      </template>
      <template #xiugaihou="scope">
        {{ scope.row.tonnageMinAfter != null && scope.row.tonnageMaxAfter != null ? scope.row.tonnageMinAfter + "-" + scope.row.tonnageMaxAfter : "" }}
      </template>
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
import XLSX from 'xlsx';

export default {
  components: {},
  name: "mould_tonage_change_log",
  data() {
    return {
      columns: [
        {
          label: "mujubianma",
          prop: "mould.code",
        },
        {
          label: "mujumingcheng",
          prop: "mould.name",
        },
        {
          label: "xiugaiqian",
          type: 'slot',
        },
        {
          label: "xiugaihou",
          type: 'slot',
        },
        {
          label: "caozuoshijian",
          prop: "createTime",
          type: "time",
          width: 180
        },
        {
          label: "xiugairen",
          prop: "createByObject.nickname",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      // table列表接口请求参数
      this.yt.conditions = {
        pageSize: 10,
        orderBy: "createTime desc",
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    exportExcel() {
      this.exportLoading = true;
      //查询表格
      this.http.get('/custom/weier/mould/tonnage/change/log/page?pageNum=1&pageSize=99999', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = this.columns.map(i => {
          if (i.label != 'caozuo') {
            return this.$t(i.label);
          }
        });
        let tableData = [];
        tableData.push(tableFirst);
        let listData = res.data.rows;
        for (let i = 0; i < listData.length; i++) {
          let dataArr = [];
          dataArr[tableFirst.indexOf(this.$t('mujubianma'))] = listData[i].mould ? listData[i]['mould'].code : '';
          dataArr[tableFirst.indexOf(this.$t('mujumingcheng'))] = listData[i].mould ? listData[i]['mould'].name : '';
          dataArr[tableFirst.indexOf(this.$t('xiugaiqian'))] = listData[i].tonnageMinBefore ? (listData[i].tonnageMinBefore + "-" + listData[i].tonnageMaxBefore) : '';
          dataArr[tableFirst.indexOf(this.$t('xiugaihou'))] = listData[i].tonnageMinAfter ? (listData[i].tonnageMinAfter + "-" + listData[i].tonnageMaxAfter) : '';
          dataArr[tableFirst.indexOf(this.$t('caozuoshijian'))] = listData[i].createTime ? this.dayjs(listData[i].createTime).format('YYYY-MM-DD HH:mm:ss') : '';
          dataArr[tableFirst.indexOf(this.$t('xiugairen'))] = listData[i].createByObject ? listData[i].createByObject.nickname : '';
          tableData.push(dataArr);
        }
        let worksheet = XLSX.utils.aoa_to_sheet(tableData);
        let workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `${this.$t('dunweirizhi')}_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.shift {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
</style>
